import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFortuneLabStore } from "../../store/useFortuneLab";
import { isEmbedMode, requestParentResize } from "../../util";

const FortuneLabLoadingPage = () => {
  const navigate = useNavigate();
  const { registeredUser, postData } = useFortuneLabStore();
  const [showLoading, setShowLoading] = useState(false);
  const embedMode = isEmbedMode();

  useEffect(() => {
    document.title = "오늘의 운세";
  }, []);

  useEffect(() => {
    if (!registeredUser) {
      navigate("/fortune-lab");
      return;
    }

    const timer = setTimeout(() => setShowLoading(true), 2000);
    return () => clearTimeout(timer);
  }, [registeredUser, navigate]);

  useEffect(() => {
    if (registeredUser && postData) {
      navigate("/fortune-lab/result");
    }
  }, [registeredUser, postData, navigate, embedMode]);

  useEffect(() => {
    if (!showLoading || !embedMode) {
      return;
    }
    requestParentResize([0, 300, 600]);
  }, [showLoading, embedMode]);

  if (!registeredUser) {
    return null;
  }

  if (!showLoading) {
    return null;
  }

  return (
    <div className="main_container">
      <main style={{ height: "100vh", overflow: "hidden" }}>
        <div className="result_loading">
          <div className="legend_backdrop">
            <div className="loading_img"></div>
            <div
              className="loading_text"
              style={{ fontWeight: 600, fontSize: "18px", marginBottom: "8px" }}
            >
              운세를 준비 중이에요 😊
            </div>
            <div className="loading_text" style={{ marginTop: "0px", fontWeight: 300 }}>
              잠시만 기다려주세요.
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default FortuneLabLoadingPage;
